import { Button, Modal } from 'antd';
import React from 'react';
import StyledContent from './styled';
import BookingPageContext from '../../../../../context';

const SuccessModal = ({ visible }) => {
  const { reloadBooking } = React.useContext(BookingPageContext);

  const handleCancel = () => {
    reloadBooking();
  };

  return (
    <Modal visible={visible} width="500px" footer={null} closable={false} onCancel={handleCancel}>
      <StyledContent>
        <h3>
          The reschedule proposal
          <br />
          was sent to the customer
        </h3>

        <p>
          We will update the booking date when they select
          <br />a new date and leave a note on the booking.
        </p>

        <Button key="submit" type="primary" onClick={handleCancel}>
          Ok, got it
        </Button>
      </StyledContent>
    </Modal>
  );
};

export default SuccessModal;
